import request from '@/utils/request'

export function main(data) {
  return request({
    url: `/api/app/browser/block-height-transaction`,
    method: 'post',
    data,
  })
}

export function table(data) {
  return request({
    url: '/api/app/browser/asset-transaction',
    method: 'post',
    data,
  })
}